import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./KeyFeatures.css";
const data = [
  { id: 1, img: "./images/tradetron2.png", title: "Platform for individuals, no coding required" },
  { id: 2, img: "./images/tradetron3.png", title: "Paper Trading" },
  { id: 3, img: "./images/position-builder.png", title: "Over 500+ Algo Strategies" },
  { id: 4, img: "./images/earn-strategy.png", title: "Backtesting" },
  { id: 5, img: "./images/nocoding.png", title: "List and earn" },
  { id: 6, img: "./images/multiple-execution.png", title: "Pro-customizations" },
];
function KeyFeatures() {
  return (
    <>
      <section className="key-features-block">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }} lg={{ span: 10, offset: 1 }}>
              <h3>Key Features</h3>
              <ul>
                {data.map((data, i) => {
                  return (
                    <li key={i}>
                       <div className="tradetronkey_group">
                        <div className="tradetronkey_imgpanel">
                          <img src={data.img} alt="img" />
                        </div>
                        <p>{data.title}</p>
                      </div>                      
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default KeyFeatures;
